import { createAsyncThunk } from '@reduxjs/toolkit';
import { getStudentGroups } from 'api/services/studentGroups';

export const getStudentGroupsAction = createAsyncThunk('studentGroups/getStudentGroups', () => {
    return getStudentGroups();
});
